import axios from "axios";


const BASE_URL = 'http://216.38.6.193:3001'



export class InFlow {
  
  private static _instance: InFlow;

  private constructor() {}

  public static get instance() {
    return this._instance || (this._instance = new this());
  }

  async listProducts(offset: number) {
    const { data } = await axios.get(
      `${BASE_URL}/api/inFlow/getAllProducts/${offset}`
    );
    return data;
  }

  async lowProducts(offset: number) {
    const { data } = await axios.get(
      `${BASE_URL}/api/inFlow/getLowQuantityProducts/${offset}`
    );
    return data;
  }

  async outofStockProducts(offset: number) {
    const { data } = await axios.get(
      `${BASE_URL}/api/inFlow/getOutOfStockProducts/${offset}`
    );
    return data;
  }


  async searchProducts(offset: number, searchQuery: string) {
    const { data } = await axios.get(
      `${BASE_URL}/api/inFlow/searchProduct/${offset}?search_query=${(searchQuery)}`
    );
    return data;
  }
  
 
  async createProduct(values: any) {
    const { data } = await axios.put(
      `${BASE_URL}/api/inFlow/createAProduct`,
      values
    );
    return data;
  }

  async editProduct(objectToReplace: any) {
    const { data } = await axios.put(
      `${BASE_URL}/api/inFlow/updateAProduct`,
      objectToReplace
    );
    return data;
  }

  async getSingleEditProduct(productId: string) {
    const { data } = await axios.get(
      `${BASE_URL}/api/inFlow/getSingleProduct/${productId}`);
    return data;
  }

  async deleteProduct(product: any) {
    const { data } = await axios.put(
      `${BASE_URL}/api/inFlow/updateAProduct`,
      product
    );
    return data;
  }

}
